export default "/images/Banner_pegada.png?49cfa927b38127d1f99334f99467f9f2";